document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const icon = btn.querySelector('.faq-icon');

      // Close others
      document.querySelectorAll('.faq-answer').forEach(a => {
        if (a !== answer) a.style.display = 'none';
      });
      document.querySelectorAll('.faq-icon').forEach(i => {
        if (i !== icon) i.textContent = '+';
      });

      // Toggle current
      if (answer.style.display === 'block') {
        answer.style.display = 'none';
        icon.textContent = '+';
      } else {
        answer.style.display = 'block';
        icon.textContent = '−';
      }
    });
  });
});
